export type SimulationRules = {
  fixedTickSeconds: number;
  baseTrainCapacity: number;
  stationOvercrowdingThreshold: number;
  overcrowdingFailureSeconds: number;
  passengerSpawnIntervalSeconds: number;
  passengerSpawnIntervalMinSeconds: number;
  trainSpeedUnitsPerSecond: number;
  trainDwellSeconds: number;
  maxSimulationSpeedMultiplier: number;
};

export const DEFAULT_SIM_RULES: SimulationRules = {
  fixedTickSeconds: 1 / 20,
  baseTrainCapacity: 8,
  stationOvercrowdingThreshold: 12,
  overcrowdingFailureSeconds: 36,
  passengerSpawnIntervalSeconds: 2.8,
  passengerSpawnIntervalMinSeconds: 1.4,
  trainSpeedUnitsPerSecond: 80,
  trainDwellSeconds: 1.3,
  maxSimulationSpeedMultiplier: 4,
};
